import React from "react";
import PropTypes from "prop-types";
import usePersonaStore from "../../Store/PersonaStore";
import FilterDropDown from "../Filters/FilterDropDown";
import { useTranslation } from "react-i18next";

/**
 * PersonaNotification - Displays selected persona with dropdown to change
 * @component
 * @example
 * <PersonaNotification />
 */
const PersonaNotification = () => {
  const { t } = useTranslation();
  const { selectedPersona, userPersonas, setSelectedPersona } = usePersonaStore();

  // Don't render if no persona is selected
  if (!selectedPersona) return null;

  // Convert personas to dropdown options format
  const personaOptions = userPersonas.map((persona, index) => ({
    id: persona.id,
    label: persona.name,
    action: () => setSelectedPersona(persona),
    value: persona._id,
  }));

  return (
    <div className="w-full flex justify-center my-4">
      <div className="bg-neutral-green-100-100 rounded-2xl shadow-sm px-4 py-4 flex items-center gap-2">
        <span className="text-gray-700 text-sm md:text-base">
          {t("eventsAndSpaces.productsShownFor")}
        </span>

        {/* Use shared FilterDropDown component with custom styling */}
        <div className="inline-block">
          <FilterDropDown
            buttonLabel={selectedPersona.name}
            options={personaOptions}
            variant="link"
            dropdownWidth="auto"
            selectedValue={selectedPersona._id}
          />
        </div>
      </div>
    </div>
  );
};

PersonaNotification.propTypes = {};

export default PersonaNotification;
